import axios from "axios";
import API_BASE from "./config";

const apiClient = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: {
    "Content-Type": "application/json",
    accept: "*/*",
  },
});

// Attach token automatically
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("tokenString");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle Unauthorized / Subscription Expired
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.Message || error?.response?.data?.message;

    if (status === 401 || status === 403) {
      if (
        message?.toLowerCase().includes("subscription expired") ||
        status === 401
      ) {
        // Clear auth data
        localStorage.clear();

        // Redirect to login
        alert("Your subscription has expired. Please renew to continue.");
        window.location.href = "/signin";
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;

/** Extract the most meaningful error message from an Axios error */
export const getApiError = (err, fallback = "Something went wrong. Please try again.") => {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.Message ||
    err?.response?.data?.error ||
    err?.message ||
    fallback
  );
};